import { Routes } from '@angular/router';
import { authGuard, publicGuard } from './features/auth/guards/auth.guard';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { adminGuard } from './core/guards/admin.guard';
import { orgUserGuard } from './core/guards/org-user.guard';
import { authorizedUserGuard } from './core/guards/authorized-user.guard';
import { manufacturerUserGuard } from './core/guards/manufacturer-user.guard';
import { LoginComponent } from './features/auth/components/login/login.component';
import { UnauthorizedComponent } from './features/auth/components/unauthorized/unauthorized.component';
import { environment } from '../environments/environment';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

// Create a guard function that redirects to home if debug info is not enabled
const debugGuard = () => {
  const router = inject(Router);
  if (!environment.showDebugInfo) {
    router.navigate(['/']);
    return false;
  }
  return true;
};

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [publicGuard]
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent
  },
  {
    path: 'debug',
    loadComponent: () => import('./features/auth/components/debug/debug-auth.component').then(m => m.DebugAuthComponent),
    canActivate: [() => debugGuard()]
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard, authorizedUserGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [authGuard, authorizedUserGuard]
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then(m => m.USER_ROUTES),
        canActivate: [authGuard, adminGuard]
      },
      {
        path: 'organisations',
        loadChildren: () => import('./features/organisations/organisations.routes').then(m => m.ORGANISATIONS_ROUTES),
        canActivate: [authGuard, adminGuard]
      },
      {
        path: 'product-categories',
        loadChildren: () => import('./features/product-categories/product-categories.routes').then(m => m.PRODUCT_CATEGORIES_ROUTES),
        canActivate: [authGuard, adminGuard]
      },
      {
        path: 'industries',
        loadChildren: () => import('./features/industries/industries.routes').then(m => m.INDUSTRIES_ROUTES),
        canActivate: [authGuard, adminGuard]
      },
      {
        path: 'manufacturers',
        loadChildren: () => import('./features/manufacturers/manufacturers.routes').then(m => m.MANUFACTURERS_ROUTES),
        canActivate: [authGuard, adminGuard]
      },
      {
        path: 'content',
        loadChildren: () => import('./features/content/content.routes').then(m => m.CONTENT_ROUTES),
        canActivate: [authGuard, adminGuard]
      },
      {
        path: 'jobs',
        loadChildren: () => import('./features/jobs/jobs.routes').then(m => m.JOBS_ROUTES),
        canActivate: [authGuard, orgUserGuard]
      },
      {
        path: 'adverts',
        loadChildren: () => import('./features/adverts/adverts.routes').then(m => m.ADVERTS_ROUTES),
        canActivate: [authGuard, manufacturerUserGuard]
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
